export default "__VITE_ASSET__44yp1M6K__"